import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as actions from "src/state/ducks/master/actions";
import { TagEntity } from "src/firebase/db/Tags";

import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import ListBlock from "src/components/molecules/list/ListBlock";
import { LinkButton } from "src/components/atoms/button/Button";

type Props = DefaultPageProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class HashtagListPage extends Component<Props> {
  componentDidMount() {
    this.props.getTags();
  }

  transferEditPage(id: string) {
    this.props.pushUrl(`/admin/master/tags/edit/${id}`);
  }

  renderList = (tags: Props["tags"]) => {
    return (
      <section>
        <ul>
          {tags.map((tag, index) => {
            const isLast = tags.length - 1 === index;
            const { id, name, is_published } = tag;
            return (
              <li key={id}>
                <ListBlock
                  clickEvent={() => this.transferEditPage(id)}
                  listText={`${name}${is_published ? "(公開)" : "(非公開)"}`}
                  listColor="primary"
                  hasEmptyLine={isLast}
                />
              </li>
            );
          })}
        </ul>
      </section>
    );
  };

  render() {
    const { tags } = this.props;
    return (
      <DefaultLayout {...this.props}>
        <Styled>
          <Heading tag="h1" color="primary" text="登録されているハッシュタグ" />
          <div className="wrapper">{this.renderList(tags)}</div>
          <div className="button">
            <LinkButton
              isDisabled={false}
              buttonColor="white"
              url="/admin/master/tags/create"
              text="ハッシュタグ作成へ"
            />
          </div>
        </Styled>
      </DefaultLayout>
    );
  }
}

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  > .button {
    margin-top: ${StyleConfig.HELPER.M20};
  }
`;

const mapStateToProps = (state: State) => ({
  tags: state.master.tags,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getTags: () => dispatch(actions.getTags()),
  createTag: (payload: Partial<TagEntity>) =>
    dispatch(actions.createTag(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HashtagListPage);
